import React from 'react';
import styles from './StatusPageContainer.module.scss';
import RentalCosts from './Charts/RentalCosts';

import Localizer from "@/localization/Localizer";
import EquipmentEmissions from "@/pages/ConstructionSiteDetails/Status/Charts/EquipmentEmissions";

interface StatusPageContainerProps {
    constructionSiteId: string;
}

const StatusPageContainer: React.FC<StatusPageContainerProps> = ({ constructionSiteId }) => {
    return (
        <div className={styles.chartsContainer}>
            <div className={styles.chart} id={"status-rental-costs-chart-container"}>
                <h2>{Localizer.constructionSiteDetailsStatusRentalCostsTitle}</h2>
                {
                    <RentalCosts constructionSiteId={constructionSiteId}/>
                }
            </div>
            <div className={styles.chart} id={"status-emission-chart-container"}>
                <h2>{Localizer.constructionSiteDetailsCo2Emissions}</h2>
            {
                <EquipmentEmissions constructionSiteId={constructionSiteId} />
            }
            </div>
        </div>
    );
};

export default StatusPageContainer;